import { useState } from "react";
import { X } from "lucide-react";

export default function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return (
    <div className="bg-brand text-white text-center text-xs sm:text-sm font-medium py-2 px-8 relative" data-testid="announcement-bar">
      🌍 Worldwide shipping now live · Get <span className="font-bold underline">10% off your first order</span> with code <span className="font-mono font-bold">WELCOME10</span>
      <button onClick={() => setOpen(false)} className="absolute right-3 top-1/2 -translate-y-1/2" aria-label="Dismiss" data-testid="announcement-close">
        <X size={16} />
      </button>
    </div>
  );
}
